// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ContestStats{box-sizing:border-box;min-height:800px;padding:15px;width:100%;position:static}.ContestStats .heading{margin-bottom:2px;border-bottom:1px solid #4c4c4c;width:640px}.ContestStats .topCamsEndLine{border-bottom:1px solid #4c4c4c;max-width:640px;margin-left:0px;border-top:0}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
